import { ConfirmTransition as AorakiConfirmTransition } from '@msaf/core-react'

interface ConfirmTransitionInterface {
  isFormDirty: boolean
}

export type LocationState = {
  isProgrammaticTransition: boolean
}

export default function ConfirmTransition({
  isFormDirty = false,
  children,
}: React.PropsWithChildren<ConfirmTransitionInterface>) {
  return (
    <>
      <AorakiConfirmTransition
        when={isFormDirty}
        actionConfig={[
          {
            key: 'continue',
            type: 'confirm',
            label: 'Discard changes',
            buttonStyle: 'primary',
          },
          {
            key: 'discard',
            type: 'cancel',
            label: 'Go back',
            buttonStyle: 'text-action',
          },
        ]}
      />
      {children}
    </>
  )
}
